module.exports = __webpack_public_path__ + "static/daans-administratie-logo-09d86a01a6547be80bb38a0b329b57aa.svg";